import React, { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { loadConfig } from './configService';

const AppLoader: React.FC = () => {
  const [configLoaded, setConfigLoaded] = useState(false);

  useEffect(() => {
    loadConfig('/env/public_env.json')
      .then(() => setConfigLoaded(true))
      .catch((error: unknown) => {
        console.error('Error loading config:', error);
      });
  }, []);

  if (!configLoaded) return null;

  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
};

export default AppLoader;
